import { render } from "./LetterReminder.vue?vue&type=template&id=3b7eedff&scoped=true&ts=true"
import script from "./LetterReminder.vue?vue&type=script&lang=ts"
export * from "./LetterReminder.vue?vue&type=script&lang=ts"

import "./LetterReminder.vue?vue&type=style&index=0&id=3b7eedff&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b7eedff"]])

export default __exports__